import {RouteProps} from 'config/navigation';
import Cities from './cities';
import CreateCity from './create-city';
import {FaCity} from 'react-icons/fa';
import CityDetails from './city-details';
import CreateDistance from './city-details/components/create-distance';
import CreateNeighborhood from 'modules/neighborhoods/pages/create-neighborhood';
import {useParams} from 'react-router-dom';
import EditNeighborhood from 'modules/neighborhoods/pages/edit-neighborhood';
import CreateAccessControl from './city-details/components/create-access-control';
import CreateBillingRecorency from './city-details/components/create-billing-recorency';

const CreateNeighborhoodWrapper: React.FC = () => {
  const {id} = useParams();
  return <CreateNeighborhood cityId={id} />;
};

const EditNeighborhoodWrapper: React.FC = () => {
  const {id} = useParams();
  return <EditNeighborhood cityId={id} />;
};

const citiesPages: RouteProps = {
  name: 'Cidades',
  path: 'cities',
  permission: 'cities.findAll',
  icon: <FaCity />,
  subRoutes: [
    {
      path: '',
      element: <Cities />,
      permissions: ['cities.findAll'],
    },
    {
      path: 'create',
      element: <CreateCity />,
      permissions: ['cities.findOne'],
    },
    {
      path: ':id',
      element: <CityDetails />,
      permissions: ['cities.findOne'],
    },
    {
      path: ':id/neighborhoods',
      element: <CityDetails activeTab="neighborhoods" />,
      permissions: ['cities.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateNeighborhoodWrapper />,
          title: 'Cadastrar bairro',
        },
        {
          path: ':neighborhoodId',
          element: <EditNeighborhoodWrapper />,
          title: 'Editar bairro',
        },
      ],
    },
    {
      path: ':id/distances',
      element: <CityDetails activeTab="distances" />,
      permissions: ['cities.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateDistance />,
          title: 'Cadastrar distância',
        },
      ],
    },
    {
      path: ':id/access-controls',
      element: <CityDetails activeTab="access-controls" />,
      permissions: ['cities.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateAccessControl />,
          title: 'Cadastrar controle de acesso',
        },
      ],
    },
    {
      path: ':id/billing-recorency',
      element: <CityDetails activeTab="billing-recorency" />,
      permissions: ['cities.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateBillingRecorency />,
          title: 'Cadastrar fechamento',
        },
      ],
    },
  ],
};

const myCityPages: RouteProps = {
  name: 'Gerênciar cidade',
  path: 'cities',
  permission: 'cities.findOne',
  icon: <FaCity />,
  addCityUrl: true,
  hidden: true,
  subRoutes: [
    {
      path: ':id',
      element: <CityDetails />,
      permissions: ['cities.findOne'],
    },
    {
      path: ':id/neighborhoods',
      element: <CityDetails activeTab="neighborhoods" />,
      permissions: ['cities.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateNeighborhoodWrapper />,
          title: 'Cadastrar bairro',
        },
        {
          path: ':neighborhoodId',
          element: <EditNeighborhoodWrapper />,
          title: 'Editar bairro',
        },
      ],
    },
    {
      path: ':id/distances',
      element: <CityDetails activeTab="distances" />,
      permissions: ['cities.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateDistance />,
          title: 'Cadastrar distância',
        },
      ],
    },
    {
      path: ':id/access-controls',
      element: <CityDetails activeTab="access-controls" />,
      permissions: ['cities.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateAccessControl />,
          title: 'Cadastrar controle de acesso',
        },
      ],
    },
    {
      path: ':id/billing-recorency',
      element: <CityDetails activeTab="billing-recorency" />,
      permissions: ['cities.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateBillingRecorency />,
          title: 'Cadastrar fechamento',
        },
      ],
    },
  ],
};

export default [citiesPages, myCityPages];
